<!--
/*
 * Компонент [InstructionsButton] — кнопка "Как подключить VPN" на основном экране.
 */
-->
<script lang="ts" setup>
import { ref, inject } from 'vue'
import InstructionsDialog from '@/components/onboarding/InstructionsDialog.vue'
import SlideOutInterfaceDownloadInstructions from '@/components/slide-out-interface/SlideOutInterfaceDownloadInstructions.vue'
import { useI18n } from 'vue-i18n'

const isDialogOpen = ref(false)
const isSheetDownloadInstructionsOpen = ref(false)
const startOnboarding = inject<() => void>('startOnboarding', () => {})
const { t } = useI18n()

function handleOpenInstructions() {
  isDialogOpen.value = false
  isSheetDownloadInstructionsOpen.value = true
}

function handleStartOnboarding() {
  isDialogOpen.value = false
  startOnboarding()
}
</script>

<template>
  <v-btn
    data-onboarding="instructions"
    variant="flat"
    color="success"
    class="text-on-surface"
    rounded="lg"
    block
    prepend-icon="ri-compass-3-line"
    @click="isDialogOpen = true"
  >
    {{ t('instructions.howToConnect') }}
  </v-btn>

  <instructions-dialog
    v-model="isDialogOpen"
    @open-instructions="handleOpenInstructions"
    @start-onboarding="handleStartOnboarding"
  />

  <slide-out-interface-download-instructions
    :isDownloadSheetOpen="isSheetDownloadInstructionsOpen"
    @close="isSheetDownloadInstructionsOpen = false"
  />
</template>
